import { RuntimeError } from '../graphql';

const NO_INTERNET_CONNECTION = 'No internet connection. Please check your connection and try again.';

const isNetworkError = (error: RuntimeError | undefined): boolean => {
  if (!error?.message) {
    return false;
  }

  const msg = error.message.toLowerCase();
  return (
    msg.includes('failed to fetch') ||
    msg.includes('network error') ||
    (msg.includes('network') && msg.includes('failed'))
  );
};

export const getUpdateErrorMessage = (runtimeError?: RuntimeError): string => {
  if (isNetworkError(runtimeError)) {
    return NO_INTERNET_CONNECTION;
  }

  if (runtimeError?.message) {
    return runtimeError.message;
  }

  return 'Error updating contact info';
};
